import { useState } from 'react';
import { useRoutingRulesPaginatedQuery } from 'src/graphql';

export const useFetchRoutingRules = (isCOI = false) => {
  const [openIds, setOpenIds] = useState<string[]>([]);

  const { data: rules, isLoading: isRoutingRulesLoading } =
    useRoutingRulesPaginatedQuery({
      pagination: { limit: 50, offset: 0 },
      orderBy: { fieldName: 'priority', direction: 'DESC' },
      isCOI,
    });

  return {
    orderedRules: rules?.routingRulesPaginated.items ?? [],
    count: rules?.routingRulesPaginated.count ?? 0,
    isRoutingRulesLoading,
    openIds,
    setOpenIds,
  };
};
